import { COMMENT_MAX_LENGTH, FIELD } from "./constants";

const TABLE = "WMTRANSACTIONCHARGE";

/**
 * The two groups reproduce the legacy form's two group boxes (AbGroupBox1 / AbGroupBox2 in
 * uWMD0012.dfm), captions verbatim. FormField renders one fieldset per group, so they sit side by
 * side as they do in Delphi.
 *
 * AsOfDate and CalculatedDays are deliberately required:false — Fields.js emits a static RequiredRule
 * with no way to make it conditional, and the legacy rule is "As Of Date is only live when Date to Use
 * = Specific As Of Date". Whichever field is inactive is disabled by the page's Date to Use rule, and
 * the real requirement is enforced in the page's validate() and again server-side. Same compromise the
 * sibling Calculate Deferred Handling Revenue screen makes for its debit lookups.
 *
 * Comment is "textarea", not "text": the Delphi control is a multi-line TMemo (Architecture.md rule 9).
 *
 * isLabelChanged: true everywhere so Fields.js uses the literal label rather than a localization
 * lookup — these captions must match the Delphi form and no localization keys exist for them.
 */
const ParametersLayout = [
    {
        groupId: 1,
        label: "Date",
        fields: [
            {
                name: FIELD.DateToUse,
                tableName: TABLE,
                label: "Date to Use",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.AsOfDate,
                tableName: TABLE,
                label: "As Of Date",
                type: "date",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.CalculatedDays,
                tableName: TABLE,
                label: "Calculated (+/- days)",
                type: "number",
                // Matches the Delphi DBArgosNumberCombo DisplayFormat ",0;-,0".
                format: "#,##0;-#,##0",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 2,
        label: "Options",
        fields: [
            {
                name: FIELD.ZeroCharges,
                tableName: TABLE,
                label: "$0 Charges",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.Comment,
                tableName: TABLE,
                label: "Comment",
                type: "textarea",
                required: false,
                maxLength: COMMENT_MAX_LENGTH,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { ParametersLayout };
